module.exports = __webpack_public_path__ + "static/04-6ef606f7b0a4e55ae5979cf28a2a06da.png";